import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import http from "../../common/http-common";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";
import save from "../../assets/save-icon.png";
import cancel from "../../assets/cancel-icon.png";

const SystemInfoModify = (props) => {

  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const systemInputRef = useRef();
  //const orgSystemInputRef = useRef();
  const remarkInputRef = useRef();

  //For Company and System List
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyList, setCompanyList] = useState([]);

  const [selectedSystem, setSelectedSystem] = useState(null);
  const [systemList, setSystemList] = useState([]);


  //For Server ENV,Type Dropdown
  const [selectedEnv, setSelectedEnv] = useState(null);
  const [selectedConn, setSelectedConn] = useState(null);
    
  const [ConnTypeListToBeSelect, setConnTypeListToBeSelect] = useState([]);
  const [ConnList, setConnList] = useState([]);
    
  const [EnvListToBeSelect, setEnvListToBeSelect] = useState([]);
  const [EnvList, setEnvList] = useState([]);

  //const [addData, setAddData] = useState([]);

  //const [dataToBeSelect, setDataToBeSelect] = useState([]);

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);

  useEffect(() => {
    if (props.editData !== null) {
      setEditData({
        ORG_ID: props.editData.ORG_ID,
        ORG_NAME: props.editData.ORG_NAME,
        SYSTEM_MST_ID: props.editData.SYSTEM_MST_ID,
        ORG_SYSTEM_DETAILS_ID: props.editData.ORG_SYSTEM_DETAILS_ID,
        ORG_SYSTEM_ID: props.editData.ORG_SYSTEM_ID,
        ACTIVE_FLAG: props.editData.ACTIVE_FLAG,
        SYSTEM_MST_NAME: props.editData.SYSTEM_MST_NAME,
        IP_ADDRESS: props.editData.IP_ADDRESS || "",
        URL: props.editData.URL || "",
        ID: props.editData.ID || "",
        PASSWORD: props.editData.PASSWORD || "",
        DB_SID: props.editData.DB_SID || "",
        REMARK: props.editData.REMARK === null ? "" : props.editData.REMARK,
      });

      setSelectedEnv({
        value: props.editData.SERVER_ENV_ID,
        label: props.editData.SERVER_ENV_NAME,
      });

      setSelectedConn({
        value: props.editData.SERVER_CONN_TYPE_ID,
        label: props.editData.SERVER_CONN_TYPE_NAME,
      }); 

      setSelectedCompany({ 
        value: props.editData.ORG_ID, 
        label: props.editData.ORG_NAME 
      });

      setSelectedSystem({ 
        value: props.editData.SYSTEM_MST_ID, 
        label: props.editData.SYSTEM_MST_NAME 
      });
    }
  }, [props.editData]);

  //#region Modal Show/Hide
  const hideModal = () => {
    setEditData([]);
    setEnvList([]);
    setConnList([]);
    //setAddData([]);
    setInputError([]);
    props.onHide();
  };
  //#endregion

  //System ENV Dropdown
  useEffect(() => {
    let functionName = "";
      try {
        functionName = "Get ENV List";
          http
            .get("api/SystemInfo/GetEnvList?_user=" + userId)
              .then((response) => {
                  const EnvList = [];
                    for (var i = 0; i < response.data.length; i++) {
                      EnvList.push({
                        key: response.data[i].SERVER_ENV_ID,
                        value: response.data[i].SERVER_ENV_ID,
                        label: response.data[i].SERVER_ENV_NAME,
                      });
                    }
                setEnvListToBeSelect(EnvList);
              })
              .catch((err) => {
                common.c_LogWebError(props.page, functionName, err);
              });
        } catch (err) {
          common.c_LogWebError(props.page, functionName, err);
          }
  }, []);
    
//System Conn Dropdown
  useEffect(() => {
    let functionName = "";
      try {
        functionName = "Get Conn List";
          http
            .get("api/SystemInfo/GetConnTypeList?_user=" + userId)
            .then((response) => {
               const ConnList = [];
                for (var i = 0; i < response.data.length; i++) {
                  ConnList.push({
                    key: response.data[i].SERVER_CONN_TYPE_ID,
                    value: response.data[i].SERVER_CONN_TYPE_ID,
                    label: response.data[i].SERVER_CONN_TYPE_NAME,
                  });
                }
              setConnTypeListToBeSelect(ConnList);
            })
            .catch((err) => {
              common.c_LogWebError(props.page, functionName, err);
            });
        } catch (err) {
          common.c_LogWebError(props.page, functionName, err);
        }
    }, []);

     useEffect(() => {
            let functionName = "";
            try {
                functionName = "Get Company List";
                http
                    .get("api/SystemInfo/GetCompanyList?_user=" + userId, { timeout: 10000 })
                    .then((response) => {
                        const companies = response.data.map((item) => ({
                            key: item.ORG_ID,
                            value: item.ORG_ID,
                            label: item.ORG_NAME,
                        }));
                        setCompanyList(companies);
                    })
                    .catch((err) => {
                        common.c_LogWebError(props.page, functionName, err);
                    });
            } catch (err) {
                common.c_LogWebError(props.page, functionName, err);
            }
        }, []);
    
        const onCompanyChange = (val) => {
            setSelectedCompany(val);
            setSelectedSystem(null); // clear previous selection
            if (val?.value) {
                let functionName = "";
                try {
                    functionName = "Get System List";
                    http
                        .get(`api/SystemInfo/GetSystemList?_user=${userId}&_orgId=${val.value}`, { timeout: 10000 })
                        .then((response) => {
                            const systems = response.data.map((item) => ({
                                key: item.SYSTEM_MST_ID,
                                value: item.SYSTEM_MST_ID,
                                label: item.SYSTEM_MST_NAME,
                            }));
                            setSystemList(systems);
                        })
                        .catch((err) => {
                            common.c_LogWebError(props.page, functionName, err);
                        });
                } catch (err) {
                    common.c_LogWebError(props.page, functionName, err);
                }
            }
        };

    const saveBtnOnClick = () => {

        var flag = true;
        const errors = {};

        if (!selectedCompany) {
          flag = false;
          errors.ORG_ID = "Company could not be empty.";
        }

        if (!selectedSystem) {
          flag = false;
          errors.SYSTEM_MST_ID = "System could not be empty.";
        }

        if (!selectedEnv) {
          flag = false;
          errors.SERVER_ENV_NAME = "System environment could not be empty.";
        }

        if (!selectedConn) {
          flag = false;
          errors.SERVER_CONN_TYPE_NAME = "Server type could not be empty.";
        }

        // Validate IP or URL — at least one must be filled
        if (!editData.IP_ADDRESS && !editData.URL) {
          flag = false;
          errors.IP_ADDRESS = "Either IP or URL must be provided.";
          errors.URL = "Either IP or URL must be provided.";
        }

        if (!editData.ID) {
          flag = false;
          errors.ID = "ID is required.";
        }

        if (!editData.PASSWORD) {
          flag = false;
          errors.PASSWORD = "Password is required.";
        }
        
        setInputError(errors);

        if (
          Object.values(errors).filter((v) => v !== "").length === 0 &&
          flag
        ) {
          SaveEditSystem();
        }
    }

    function SaveEditSystem() {
        let functionName = "";
        try {
            functionName = SaveEditSystem.name;
            props.onLoading(true, "Modifying system, please wait...");
            
            const selectedEnvID = selectedEnv?.value;
            const selectedConnID = selectedConn?.value;

            const data = {
              ORG_ID: selectedCompany?.value,
              ORG_SYSTEM_DETAILS_ID: editData.ORG_SYSTEM_DETAILS_ID,
              ORG_SYSTEM_ID: editData.ORG_SYSTEM_ID,
              SYSTEM_MST_ID: selectedSystem?.value,
              ACTIVE_FLAG: editData.ACTIVE_FLAG,
              SYSTEM_MST_NAME: selectedSystem?.label,
              //SERVER_ENV_NAME: addData.SERVER_ENV_NAME;
              //SERVER_CONN_TYPE_NAME: selectedType?.SERVER_CONN_TYPE_NAME || "",
              SERVER_ENV_ID: selectedEnvID,
              SERVER_CONN_TYPE_ID: selectedConnID,
              IP_ADDRESS: editData.IP_ADDRESS,
              URL: editData.URL,
              ID: editData.ID,
              PASSWORD: editData.PASSWORD,
              DB_SID: editData.DB_SID || "",
              REMARK: editData.REMARK || "",
              UPDATE_ID: userId,
              FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },

            };

            //console.log(data);
            http
              .put("api/SystemInfo/UpdateSys", data, { timeout: 5000 })
              .then((response) => {
                if (response.data.DUPLICATE_SYSTEM_MST_NAME === true) {
                  toast.error("System already exist.");
                  } else {
                  toast.success("System is successfully inserted.");
                  props.onReload();
                  hideModal();
                }
              })
              .catch((err) => {
                toast.error("Failed to modify System. Please try again.");
                common.c_LogWebError(props.page, functionName, err);
              })
              .finally(() => {
                props.onLoading(false, "Loading...");
              });
        } catch (err) {
            props.onLoading(false, "Loading...");
            toast.error("Failed to modify System. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          }
    };

    const inputRequiredHandler = (event) => {
        let functionName = "";

        try {
            functionName = inputRequiredHandler.name;
            const name = event.target.name;
            functionName = inputRequiredHandler.name + "_" + name;
            const id = event.target.id;
            const val = event.target.value;
            if (val.length === 0 || val.trim().length === 0) {
                setInputError((prevState) => ({
                    ...prevState,
                    [id]: (name + " could not be empty."),
                }));
            } else {
                setInputError((prevState) => ({
                    ...prevState,
                    [id]: (""),
                }));
            }
            setEditData((prevState) => ({
                ...prevState,
                [id]: val,
            }));
        } catch (err) {
            common.c_LogWebError(props.page, functionName, err);
        }
    }

    const inputUnrequiredHandler = (event) => {
        let functionName = "";

        try {
            functionName = inputUnrequiredHandler.name;
            const name = event.target.name;
            functionName = inputUnrequiredHandler.name + "_" + name;
            const id = event.target.id;
            const val = event.target.value;

            setEditData((prevState) => ({
                ...prevState,
                [id]: val,
            }));
        } catch (err) {
            common.c_LogWebError(props.page, functionName, err);
        }
    }


    const selectEnvListHandler = (val) => {
                let functionName = "";
            
                try {
                  functionName = selectEnvListHandler.name;
                  if (Object.keys(val).length > 0) {
                    setInputError((prevState) => ({
                      ...prevState,
                      SERVER_ENV_NAME: "",
                    }));
                  } else {
                    setInputError((prevState) => ({
                      ...prevState,
                      SERVER_ENV_NAME: "Server Environment could not be empty.",
                    }));
                  }
                  setEnvList([...val]);
                } catch (err) {
                    common.c_LogWebError(props.page, functionName, err);
                }
    };
    
    
    const selectConnListHandler = (val) => {
                let functionName = "";
            
                try {
                  functionName = selectConnListHandler.name;
                  if (Object.keys(val).length > 0) {
                    setInputError((prevState) => ({
                      ...prevState,
                      SERVER_CONN_TYPE_NAME: "",
                    }));
                  } else {
                    setInputError((prevState) => ({
                      ...prevState,
                      SERVER_CONN_TYPE_NAME: "Server Environment could not be empty.",
                    }));
                  }
                  setConnList([...val]);
                } catch (err) {
                  common.c_LogWebError(props.page, functionName, err);
                }
      };

      return (
        <>
            <Modal show={props.showHide} onHide={hideModal} centered>
                <Modal.Header>
                    <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
                        <Modal.Title>MODIFY</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Comp.Select
                      id="ORG_ID"
                      label="Company*:"
                      options={companyList}
                      errorMessage={inputError.ORG_ID}
                      value={selectedCompany}
                      onChange={(val) => {
                        onCompanyChange(val); // <-- dynamically fetch system list
                        setInputError((prev) => ({ ...prev, ORG_ID: "" }));
                      }}
                    />

                    <Comp.Select
                      id="SYSTEM_MST_ID"
                      label="System*:"
                      options={systemList}
                      errorMessage={inputError.SYSTEM_MST_ID}
                      value={selectedSystem}
                      onChange={(val) => {
                        setSelectedSystem(val);
                        setInputError((prev) => ({ ...prev, SYSTEM_MST_ID: "" }));
                      }}
                    />

                    <Comp.Select
                        id="SERVER_ENV_ID"
                        label="Prod. / Dev.*:"
                        type="text"
                        options={EnvListToBeSelect}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        errorMessage={inputError.SERVER_ENV_NAME}
                        value={selectedEnv}
                        onChange={(val) => setSelectedEnv(val)}
                        autoComplete="off"
                    />
                    
                     <Comp.Select
                        id="SERVER_CONN_TYPE_ID"
                        label="Server Type*:"
                        type="text"
                        options={ConnTypeListToBeSelect}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        errorMessage={inputError.SERVER_CONN_TYPE_NAME}
                        value={selectedConn}
                        onChange={(val) => setSelectedConn(val)}
                        autoComplete="off"
                      />
                                        
                      <Comp.Input
                        id="IP_ADDRESS"
                        label="IP:"
                        name="IP"
                        type="text"
                        className="form-control"
                        errorMessage={inputError.IP_ADDRESS}
                        value={editData.IP_ADDRESS || ""}
                        onChange={inputUnrequiredHandler}
                      />
                      
                      <Comp.Input
                        id="URL"
                        label="URL:"
                        name="URL"
                        type="text"
                        className="form-control"
                        errorMessage={inputError.URL}
                        value={editData.URL || ""}
                        onChange={inputUnrequiredHandler}
                      />
                    
                      <Comp.Input
                        id="ID"
                        label="ID*:"
                        name="ID"
                        type="ID"
                        className="form-control"
                        errorMessage={inputError.ID}
                        value={editData.ID}
                        onChange={inputRequiredHandler}
                      />
                    
                      <Comp.Input
                        id="PASSWORD"
                        label="Password*:"
                        name="Password"
                        type="password"
                        className="form-control"
                        errorMessage={inputError.PASSWORD}
                        value={editData.PASSWORD}
                        onChange={inputRequiredHandler}
                      />
                    
                      <Comp.Input
                        id="DB_SID"
                        label="DB SID:"
                        name="DB SID"
                        type="text"
                        className="form-control"
                        value={editData.DB_SID}
                        onChange={inputUnrequiredHandler}
                      />
                    
                    <Comp.Input
                        ref={remarkInputRef}
                        id="REMARK"
                        label="Remark:"
                        type="text"
                        className="form-control"
                        value={editData.REMARK}
                        onChange={inputUnrequiredHandler}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <div style={{ textAlign: "center", width: "100%" }}>
                        <Comp.Button id="btnSave" onClick={saveBtnOnClick}>
                            Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
                        </Comp.Button>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <Comp.Button
                            id="btnCancel"
                            type="cancel"
                            onClick={hideModal}
                        >
                            Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
                        </Comp.Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
      );

};

export default SystemInfoModify;